"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _pluralize = _interopRequireDefault(require("pluralize"));

var _reReselect = _interopRequireDefault(require("re-reselect"));

var _selectEntityByKeyAndJoin = _interopRequireDefault(require("./selectEntityByKeyAndJoin"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var mapArgsToCacheKey = function mapArgsToCacheKey(state, activityIdentifier) {
  return activityIdentifier || ' ';
};

var _default = (0, _reReselect["default"])(function (state) {
  return state.data;
}, function (state, activityIdentifier) {
  return activityIdentifier;
}, function (data, activityIdentifier) {
  if (!activityIdentifier) return;
  var __activities__ = data.__activities__;
  var firstActivity = (0, _selectEntityByKeyAndJoin["default"])({
    data: {
      __activities__: __activities__
    }
  }, '__activities__', {
    key: 'identifier',
    value: activityIdentifier
  });

  if (firstActivity && firstActivity.modelName) {
    var key = (0, _pluralize["default"])("".concat(firstActivity.modelName[0].toLowerCase()).concat(firstActivity.modelName.slice(1)));
    return (0, _selectEntityByKeyAndJoin["default"])({
      data: _defineProperty({}, key, data[key])
    }, key, {
      key: 'activityIdentifier',
      value: activityIdentifier
    });
  }

  var entityFoundByBruteSearch;
  Object.keys(data).find(function (key) {
    if (key === '_persist' || key === '__activities__' || !Array.isArray(data[key])) return;
    entityFoundByBruteSearch = (0, _selectEntityByKeyAndJoin["default"])({
      data: _defineProperty({}, key, data[key])
    }, key, {
      key: 'activityIdentifier',
      value: activityIdentifier
    });
    return entityFoundByBruteSearch;
  });
  return entityFoundByBruteSearch;
})(mapArgsToCacheKey);

exports["default"] = _default;